import type {
  CompetitionView,
  EventBasedMarketView,
  EventTypeView,
  EventView
} from '@ps/web-sports-api-types';
import { MarketLevel } from '@ps/web-sports-api-types';
import type { SportsEvent } from 'schema-dts';

import { useGenerateSportsEventUrl } from './useGenerateSportsEventUrl';

const AVB_EVENT_MARKET_LEVEL = MarketLevel.AVB_EVENT;

export interface SportsEventProps {
  event: EventView;
  market: EventBasedMarketView;
  eventType?: EventTypeView;
  competition?: CompetitionView;
}

export const useFormatSportsEvent = ({
  event,
  market,
  eventType,
  competition
}: SportsEventProps): SportsEvent | undefined => {
  const sportsEventUrl = useGenerateSportsEventUrl({ event, eventType, competition });

  if (!eventType || !sportsEventUrl) {
    return;
  }

  const competitionName = competition?.competitionName;

  if (!competitionName) {
    return;
  }

  const isAvBEvent = market.marketLevels.includes(AVB_EVENT_MARKET_LEVEL);

  if (!isAvBEvent) {
    return;
  }

  const [homeTeam, awayTeam] = event.enrichedParticipants
    ? event.enrichedParticipants.map(({ participant }) => participant)
    : [];

  return {
    '@type': 'SportsEvent',
    homeTeam: homeTeam
      ? {
          '@type': 'SportsTeam',
          name: homeTeam
        }
      : undefined,
    awayTeam: awayTeam
      ? {
          '@type': 'SportsTeam',
          name: awayTeam
        }
      : undefined,
    sport: eventType.name,
    name: event.eventName,
    startDate: event.eventStartTime,
    url: sportsEventUrl,
    location: {
      '@type': 'Place',
      name: competitionName,
      address: {
        '@type': 'PostalAddress',
        name: competitionName
      }
    }
  };
};
